<template>
  <div id="app">
    <router-view class="width: 100%;height: 100%;padding-bottom: 75px;"></router-view>
    <div id="tab-bar" v-if="$route.path == '/' || $route.path == '/userInfo' ">
      <div class="tab-bar-item" @click="goHome">
        <div>
          <img v-if="$route.path == '/'" src="./assets/shouye.png" alt="">
          <img v-if="$route.path == '/userInfo'" src="./assets/shouyehuise.png" alt="" >
        </div>
        <div style="color: rgb(0, 0, 0)">
          <div>首页</div>
        </div>
      </div>
      <div class="tab-bar-item" @click="goUser">
        <div>
          <img v-if="$route.path == '/userInfo'" src="./assets/wode.png" alt="" >
          <img v-if="$route.path == '/'"  src="./assets/wodehuise.png" alt="" >
        </div>
        <div>
          <div>我的</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data  () {
// 这里存放数据
    return {
      userLint:[]
    }
  },
// 监听属性 类似于data概念
  computed: {},
// 监控data中的数据变化
  watch: {},
// 方法集合
  methods: {
    goHome(){
      console.log(11111)
      this.$router.push("/")
    },
    goUser(){
      console.log(22)
      this.$router.push("/userInfo")
    },
   async registWxSdk(){
      this.$http.get(`/api/te/wx/login?url=${encodeURIComponent(window.location.href)}`)
        .then((res) => {
          console.log("regeister",JSON.stringify(res));
          if (res.data) {
            const { timestamp, nonceStr, signature, appId } = res.data.result;
            // @ts-ignore
            wx.config({
              debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
              appId, // 必填，公众号的唯一标识
              timestamp, // 必填生成签名的时间戳
              nonceStr, // 必填，生成签名的随机串
              signature, // 必填，签名
              jsApiList: ["startRecord", "stopRecord", "uploadVoice", "translateVoice", "onVoicePlayEnd", "playVoice", "pauseVoice"] // 必填，需要使用的 JS 接口列表
            });
          }
        })
        .catch((err) => { });
    }
  },
// 生命周期 - 创建完成（可以访问当前this实例）
  // 生命周期-创建完成（可以访问当前this实例）
  created() {

    const queryString = window.location.search;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    // alert(navigator.userAgent);
    // alert(isIOS);
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("code");
    const state = urlParams.get("state")?.toString() || "";
    let saleId = urlParams.get("saleId")?.toString() || "";
    let userId = urlParams.get("userId") ? urlParams.get("userId") : null;
    try {
      if (state != "") {
        // const extraParams = JSON.parse(decodeURIComponent(state));
        const extraParams = JSON.parse(state);
        saleId = extraParams.saleId;
        userId = extraParams.userId; // 0默认登录  1分销产品  2 一级销售添加下级销售
      }
    } catch (e) {
      new Error(e);
    }
    if (code && state != "") {
      // if (true) {
      this.$http.get("https://www.shqsm.cn/tempt/api/sjte/wx/login", {
        params: {
          code,
          userId: userId,
          saleId
        }
      })
        .then((response) => {
          if (response.success) {
            localStorage.setItem("user", JSON.stringify(response.result));
            localStorage.setItem("token", response.result.token);
            localStorage.setItem("openid", response.result.openid);
            localStorage.setItem("phoneExt", response.result.phoneExt);
            // setToken(response.result.token);
            localStorage.setItem("saleId", saleId);
            localStorage.setItem("code", code);

            //根据isRegister判断：如果false，则跳转注册页面，否则直接进入首页
            if (!response.result.isRegister) {
              this.$router.push("/login")
            }
            if (isIOS) {
              console.log("当前设备为iOS系统");
              this.registWxSdk();
            } else {
              console.log("当前设备不是iOS系统");
            }
          } else {
            //访问微信使其重定向到这
            const extraParams = {
              saleId: saleId,
              userId: userId
            };
            const stateInfo = JSON.stringify(extraParams);
            // const stateInfo = encodeURIComponent(JSON.stringify(extraParams));
            const redirectUri = "https://www.shqsm.cn/"; //当前页面的地址
            const appID = "wx91a7acc50b5a82e2"; //当前页面的地址
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
          }
        })
        .catch((error) => {
          console.error("Failed to get voice data from server:", error);
        });
    } else {
      //访问微信使其重定向到这
      const extraParams = {
        saleId: saleId,
        userId: userId
      };
      const stateInfo = JSON.stringify(extraParams);
      // const stateInfo = encodeURIComponent(JSON.stringify(extraParams));
      /**
       * 此地址是登陆微信认证之后重定向的链接
       */
      const redirectUri = "https://www.shqsm.cn/";
      const appID = "wx91a7acc50b5a82e2"; //当前页面的地址
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }

  },
// 生命周期 - 挂载完成（可以访问DOM元素）
  mounted  () {

  },
  beforeCreate  () {}, // 生命周期 - 创建之前
  beforeMount  () {}, // 生命周期 - 挂载之前
  beforeUpdate  () {}, // 生命周期 - 更新之前
  updated  () {}, // 生命周期 - 更新之后
  beforeDestroy  () {}, // 生命周期 - 销毁之前
  destroyed  () {}, // 生命周期 - 销毁完成
  activated  () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
#tab-bar{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    -webkit-box-shadow: inset 0 1px 0 0 #eee;
    box-shadow: inset 0 1px 0 0 #eee;
    z-index: 1;
}
.tab-bar-item {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 56px;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: rgba(0, 0, 0, .4);
    text-align: center; 
}
.tab-bar-item img {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-top: 9px;
    vertical-align: middle;
}
</style>
